/* @flow */

import WebshopProductCarouselSettings from './WebshopProductCarouselSettings'
import WebshopProductCarousel from './WebshopProductCarousel'

const widget = {
  component: WebshopProductCarousel,
  settings: WebshopProductCarouselSettings,

  available_children: [],
  label: 'Product carousel',

  default_settings: {
    headline: '',
    headline_position: 'left',
    product_width: '200px',
    products: [],
    space_between_each_product: '',
  },
  default_style: {},
}

export default widget
